import ScalarIconTag_vue_vue_type_script_setup_true_lang_default from "./ScalarIconTag.vue.script.js";
//#region src/components/ScalarIconTag.vue
var ScalarIconTag_default = ScalarIconTag_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconTag_default as default };

//# sourceMappingURL=ScalarIconTag.js.map